import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', href: '/' },
  { label: '快速入门', href: '/category/quick-start' },
  { label: '布局设计', href: '/category/layout-design' },
  { label: '主题定制', href: '/category/custom-theme' },
  { label: '关于我们', href: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-[42px] h-[42px] flex items-center justify-center">
              <i className={`ri-navigation-fill text-2xl transition-colors duration-300 ${scrolled ? 'text-primary-500' : 'text-background-50'}`}></i>
            </div>
            <span className={`text-lg font-semibold tracking-tight transition-colors duration-300 ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              蓝色小导航
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`relative px-3 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? scrolled
                        ? 'text-primary-600 bg-primary-50'
                        : 'text-background-50 bg-white/15'
                      : scrolled
                        ? 'text-foreground-600 hover:text-primary-600 hover:bg-background-100'
                        : 'text-background-50/85 hover:text-background-50 hover:bg-white/10'
                  }`}
                >
                  {link.label}
                  {isActive && (
                    <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-[2px] bg-primary-500 rounded-full" />
                  )}
                </Link>
              );
            })}
          </nav>

          <button
            className={`md:hidden w-[42px] h-[42px] flex items-center justify-center rounded-lg transition-colors duration-200 ${
              scrolled ? 'text-foreground-800 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50 border-t border-background-200/70 px-4 py-3 space-y-1">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.href}
                to={link.href}
                className={`block px-3 py-2.5 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap ${
                  isActive
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      </div>
    </header>
  );
}